import { NextResponse } from "next/server";
import { cookies } from "next/headers";
import axios from "axios";
import { BaseURL } from "@/Utils/APIRequest/Endpoints";
const LOGIN_REDIRECT_URL =
  process.env.WEBSITE_URL + "register/influencer/steps";
const PROFILE_REDIRECT_URL =
  process.env.WEBSITE_URL + "influencer/profile/social-media-account";
const JOBS_REDIRECT_URL = process.env.WEBSITE_URL + "influencer/my-jobs";
const DASHBOARD_REDIRECT_URL = process.env.WEBSITE_URL + "influencer/dashboard";

export async function POST(req) {
  const cookieStore = await cookies();
  const accessToken =
    cookieStore.get("iat")?.value || cookieStore.get("verifyUAT")?.value;

  let requestData;
  try {
    requestData = await req.json(); // Only read once
    const { code, type } = requestData;

    const REDIRECT_URL =
      type === "profile"
        ? PROFILE_REDIRECT_URL
        : type === "jobs"
          ? JOBS_REDIRECT_URL
          : type === "dashboard"
            ? DASHBOARD_REDIRECT_URL
            : LOGIN_REDIRECT_URL;

    const formData = new FormData();
    formData.append("client_id", process.env.INSTAGRAM_CLIENT_ID);
    formData.append("client_secret", process.env.INSTAGRAM_SECRET_ID);
    formData.append("grant_type", "authorization_code");
    formData.append("redirect_uri", REDIRECT_URL);
    formData.append("code", code);

    const response = await axios.post(
      "https://api.instagram.com/oauth/access_token",
      formData,
      {
        params: {
          client_id: process.env.INSTAGRAM_CLIENT_ID,
          client_secret: process.env.INSTAGRAM_SECRET_ID,
          grant_type: "authorization_code",
          redirect_uri: REDIRECT_URL,
          code: code,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
        },
      }
    );

    return NextResponse.json({ data: response.data });
  } catch (error) {
    let payload;

    if (error.response) {
      payload = {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
      };
    } else {
      payload = {
        message: error.message,
      };
    }

    let body = {
      module: "instagram_authorization_code",
      name: error.response.data.error_type,
      message: error.response.data.error_message,
      context: {
        url: "https://api.instagram.com/oauth/access_token",
        code: requestData?.code,
        type: "login",
      },
    };

    await axios.post(`${BaseURL}auth/error-log`, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    });

    return NextResponse.json(
      { error: payload },
      { status: error.response ? error.response.status : 500 }
    );
  }
}
